/**
 * @file STARS作成
 */
'use strict';

/**
 * @classname InputRadioToggle
 * @classdesc STARS作成
 */
export default class InputRadioToggle {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('InputRadioToggle.constructor');
		this._$e = $e;
		this._$target = $(`.${$e.attr('data-target')}`)
		this._$target2 = $(`.${$e.attr('data-target-2')}`)

		this._viewValue = $e.attr('data-view-value')
		this._viewValue2 = $e.attr('data-view-value-2')

		//同じnameのラジオボタン
		this._$radioButtons = $e.find('input[type="radio"]');
		
		//子要素のinput項目
		this._$inputs = this._$target.find('input, textarea, select, radio');
		this._$inputs2 = this._$target2.find('input, textarea, select, radio');

		const self = this;

		//子要素のinputの中で必須項目になっているもの
		this._$requireds = [];
		this._$requireds2 = [];
		this._$target.each(function() {
			const required = $(this).find("[data-validate='empty']");
			if(required.length > 0) {
				if(!required.hasClass('input-hidden')){
					self._$requireds.push(required);
				}
			}
		});
		this._$target2.each(function() {
			const required2 = $(this).find("[data-validate='empty']");
			if(required2.length > 0) {
				self._$requireds2.push(required2);
			}
		});

		this._$radioButtons.on('change', () => this.onChange());
		this.onChange()
	};


	/**
	 * ラジオボタン切り替え
	 *
	 * @memberof InputRadioToggle
	 * @return {undefined}
	 */
	 onChange() {
		console.log('InputRadioToggle.onChange');

		this.radioToggle(this._viewValue, this._$target, this._$requireds, this._$inputs)
		this.radioToggle(this._viewValue2, this._$target2, this._$requireds2, this._$inputs2)

	};

	/**
	 * ラジオボタン切り替え
	 *
	 * @memberof InputRadioToggle
	 * @return {undefined}
	 */
	radioToggle(viewValue, target, requireds, inputs) {
		console.log('InputRadioToggle.radioToggle');
		const val = this._$e.find('input[type="radio"]:checked').val();
		const self = this;

		$(target).each(function() {
			if(val === viewValue ){
				console.log('$(this).attr(class)::' + $(this).attr('class'));
				$(this).removeClass('hide');
				//必須項目のバリデーションを戻す
				if($(requireds).length > 0){
					for (let i = 0; i < $(requireds).length; i++) {
						$(requireds)[i].removeClass('ignore-validate');
					};				
				}
				//input項目のdisabledを外す
				if($(inputs) && $(inputs).length > 0){
					$(inputs).each(function() {
						if(!$(this).hasClass('input-hidden')){
							$(this).prop('disabled', false);
						}
					});
				}
			} else {
				$(this).addClass('hide');
				//必須項目のバリデーションを外す
				if($(requireds).length > 0){
					for (let i = 0; i < $(requireds).length; i++) {
						$(requireds)[i].attr('data-validate', '');
						$(requireds)[i].addClass('ignore-validate');
						$(requireds)[i].removeClass('is-invalid');
					};
				}
				//input項目のdisabledをつけてサーバー側に送らない
				if($(inputs) && $(inputs).length > 0){
					$(inputs).each(function() {
						if(!$(this).hasClass('input-hidden')){
							$(this).prop('disabled', true);
						}
					});
				}
			}
		});
	};
}
